module.exports = __webpack_public_path__ + "static/media/AMAZON_PRETO.0cf0109b.svg";